import React from 'react';
import { withRouter } from 'next/router';
import { connect } from 'react-redux';
import getConfig from 'next/config';
import once from 'lodash.once';
import {
  fetchMarginAssets,
  fetchMarginAccount,
  setMarginStatus,
  fetchMarginCoeff,
  fetchInterestRate,
} from '../actions/actionsSet/margin';
import { fetchTradeOrders } from '../actions/actionsSet/order';
import { getItem, setItem } from '../utils/localStorage';

const {
  publicRuntimeConfig: {
    enableMargin,
  },
} = getConfig();

const mapStateToProps = ({
  isLoggedIn,
  userInfo: {
    isExistMarginAccount,
  },
}) => ({
  isLoggedIn,
  isExistMarginAccount,
});
const mapDispatchToProps = {
  fetchMarginAssets,
  fetchMarginAccount,
  fetchTradeOrders,
  setMarginStatus,
  fetchInterestRate,
  fetchMarginCoeff,
};

type Props = {
  locale: string,
  isLoggedIn: bool,
  isExistMarginAccount: bool,
  useAccount?: bool,
  useWs: bool,
  fetchMarginAssets: Function,
  fetchMarginAccount: Function,
  fetchTradeOrders: Function,
  setMarginStatus: Function,
  router: Object,
  fetchInterestRate: Function,
  fetchMarginCoeff: Function
}

export default
@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
class MarginDataProvider extends React.PureComponent<Props> {
  static defaultProps = {
    useWs: false,
    useAccount: true,
  }

  componentDidMount() {
    const { router: { query: { type } } } = this.props;
    this.onceFetchInterestRate = once(this.props.fetchInterestRate);
    this.onceFetchMarginCoeff = once(this.props.fetchMarginCoeff);
    if (type) setItem(window.localStorage, 'margin.status', type === 'margin');
    const marginStatus = getItem(window.localStorage, 'margin.status');
    this.props.setMarginStatus(marginStatus);
    this._fetchData();
  }

  componentDidUpdate() {
    this._fetchData();
  }

  _fetchData() {
    if (!enableMargin) return;
    const {
      useWs,
      locale,
      useAccount,
      isLoggedIn,
      isExistMarginAccount,
    } = this.props;
    if (!isLoggedIn || !isExistMarginAccount) return;
    this.onceFetchInterestRate();
    this.onceFetchMarginCoeff();
    this.props.fetchMarginAssets();
    if (useWs) {
      const end = new Date();
      const start = new Date(end);
      start.setDate(end.getDate() - 1);
      this.props.fetchTradeOrders(
        {
          startTime: start.getTime(),
          endTime: end.getTime(),
          page: 1,
          rows: 200,
        },
        locale,
        false,
        true
      );
    }
    if (useAccount) {
      this.props.fetchMarginAccount();
    }
  }

  render() {
    return null;
  }
}
